import React from 'react'
import '@mantine/charts/styles.css'
import { MantineProvider, createTheme } from '@mantine/core'
import '@mantine/core/styles.css'
import { ModalsProvider } from '@mantine/modals'
import { Notifications } from '@mantine/notifications'
import '@mantine/notifications/styles.css'
import { BrowserRouter, useNavigate } from 'react-router-dom'
import AppRoutes from './routes'
import { useAuthStore } from './store'
import { useEffect } from 'react'

const theme = createTheme({})

function AppContent() {
  const navigate = useNavigate()
  const { isLoggedIn, setupActivityDetection, setNavigate } = useAuthStore()

  useEffect(() => {
    setNavigate(navigate)
  }, [navigate])

  useEffect(() => {
    if (isLoggedIn) {
      const cleanup = setupActivityDetection()
      return cleanup
    }
  }, [isLoggedIn])

  return (
    <div className="App">
      <AppRoutes />
    </div>
  )
}

function App() {
  return (
    <MantineProvider theme={theme}>
      <ModalsProvider>
        <Notifications />
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <AppContent />
        </BrowserRouter>
      </ModalsProvider>
    </MantineProvider>
  )
}

export default App
